import React from "react";
import { useT, useLang } from "../context/I18nContext";

export default function Impressum() {
  const t = useT();
  const { t: tKey } = useLang();

  return (
    <div className="page-shell" data-testid="impressum-page">
      <section className="site-container page-hero !max-w-[1100px]">
        <div className="eyebrow mb-6">{t({ DE: "Rechtliches", EN: "Legal", RU: "Правовая информация", UA: "Юридична інформація" })}</div>
        <h1 className="page-title">
          {t({ DE: "Impressum.", EN: "Imprint.", RU: "Импрессум.", UA: "Імпресум." })}
        </h1>
      </section>

      <section className="site-container section-block !max-w-[1100px]">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="eyebrow mb-5">{t({ DE: "Medieninhaber & Herausgeber", EN: "Media owner & publisher", RU: "Издатель", UA: "Видавець" })}</div>
            <div className="font-display text-2xl mb-4 leading-tight">ECO BUILDING TECHNIK GMBH</div>
            <div className="text-sm text-white/75 leading-relaxed space-y-1">
              <div>Seepromenade 109</div>
              <div>AT-2384 Ebreichsdorf</div>
              <div>{t({ DE: "Österreich", EN: "Austria", RU: "Австрия", UA: "Австрія" })}</div>
            </div>
            <div className="mt-6">
              <div className="text-[11px] uppercase tracking-[0.15em] text-white/45 mb-1">
                {tKey("footer.gf")}
              </div>
              <div className="text-sm text-white/90">Johannes Fernberg</div>
            </div>
          </div>

          <div className="md:col-span-7 space-y-10">
            <Block label={t({ DE: "Kontakt", EN: "Contact", RU: "Контакт", UA: "Контакт" })}>
              <Row k={t({ DE: "Mobil", EN: "Mobile", RU: "Моб.", UA: "Моб." })} v={<a href="tel:+436643289599" className="hover:text-[#5FA637] transition-colors">+43 664 328 95 99</a>}/>
              <Row k="E-Mail" v={<a href="mailto:office@eco-building.tech" className="hover:text-[#5FA637] transition-colors">office@eco-building.tech</a>}/>
              <Row k={t({ DE: "Internet", EN: "Web", RU: "Сайт", UA: "Сайт" })} v={<a href="https://eco-gebaeudetechnik.com" target="_blank" rel="noreferrer" className="hover:text-[#5FA637] transition-colors">eco-gebaeudetechnik.com</a>}/>
            </Block>

            <Block label={t({ DE: "Firmenbuch / UID", EN: "Company registration / VAT ID", RU: "Регистрация компании / НДС", UA: "Реєстрація компанії / ПДВ" })}>
              <p className="text-sm text-white/60 leading-relaxed italic">
                {t({
                  DE: "Firmenbuchnummer, UID-Nummer und zuständiges Firmenbuchgericht werden ergänzt.",
                  EN: "Company registration number, VAT ID and competent commercial register will be added.",
                  RU: "Регистрационный номер, НДС и компетентный суд будут добавлены.",
                  UA: "Реєстраційний номер, ПДВ та компетентний суд будуть додані.",
                })}
              </p>
            </Block>

            <Block label={t({ DE: "Unternehmensgegenstand", EN: "Business activity", RU: "Деятельность", UA: "Діяльність" })}>
              <p className="text-sm text-white/75 leading-relaxed">
                {t({
                  DE: "Planung, Lieferung, Koordination und Betreuung moderner Haustechnik und Gebäudetechnik — Technische Planung, BIM, Heizung, Wärmepumpen, Warmwasser, Kühlung, Energie, Photovoltaik, Energiemanagement, Gebäudeautomation, Licht, Beschattung, Zutritt, Sensorik, Materialbereitstellung, Inbetriebnahme, Wartung und Service.",
                  EN: "Planning, supply, coordination and support of modern building services — technical planning, BIM, heating, heat pumps, hot water, cooling, energy, photovoltaics, energy management, building automation, lighting, shading, access, sensors, materials, commissioning, maintenance and service.",
                  RU: "Проектирование, поставка, координация и сопровождение современных инженерных систем — техническое проектирование, BIM, отопление, тепловые насосы, ГВС, охлаждение, энергия, ФЭ, энергоменеджмент, автоматизация зданий, свет, солнцезащита, доступ, датчики, материалы, пусконаладка, обслуживание и сервис.",
                  UA: "Проєктування, постачання, координація та супровід сучасної інженерної техніки — технічне проєктування, BIM, опалення, теплові насоси, ГВП, охолодження, енергія, ФЕ, енергоменеджмент, автоматизація будівель, світло, сонцезахист, доступ, датчики, матеріали, пусконалагодження, обслуговування та сервіс.",
                })}
              </p>
            </Block>

            <Block label={t({ DE: "Anwendbare Rechtsvorschriften", EN: "Applicable law", RU: "Применимое право", UA: "Застосовне право" })}>
              <p className="text-sm text-white/75 leading-relaxed">
                {t({
                  DE: "Es gelten die Gewerbeordnung (GewO) sowie die einschlägigen Vorschriften des österreichischen Rechts.",
                  EN: "The Austrian Trade Code (GewO) and applicable Austrian law apply.",
                  RU: "Применяется Австрийский торговый кодекс (GewO) и соответствующие нормы австрийского права.",
                  UA: "Застосовується Австрійський торговий кодекс (GewO) та відповідні норми австрійського права.",
                })}
              </p>
            </Block>

            <Block label={t({ DE: "Haftungsausschluss", EN: "Liability disclaimer", RU: "Отказ от ответственности", UA: "Відмова від відповідальності" })}>
              <p className="text-sm text-white/75 leading-relaxed">
                {t({
                  DE: "Technische Aussagen auf dieser Website sind projektabhängig. Pauschale Garantien zu Energieeinsparung oder Wirtschaftlichkeit werden nicht abgegeben. Für die Inhalte externer Links sind ausschließlich deren Betreiber verantwortlich.",
                  EN: "Technical statements on this website are project-dependent. Blanket guarantees regarding energy savings or profitability are not given. The respective operators are solely responsible for external link content.",
                  RU: "Технические заявления зависят от проекта. Общие гарантии экономии или рентабельности не даются. Ответственность за внешние ссылки несут их владельцы.",
                  UA: "Технічні заяви залежать від проєкту. Загальні гарантії економії або рентабельності не надаються. Відповідальність за зовнішні посилання несуть їх власники.",
                })}
              </p>
            </Block>

            <Block label={t({ DE: "Urheberrecht", EN: "Copyright", RU: "Авторское право", UA: "Авторське право" })}>
              <p className="text-sm text-white/75 leading-relaxed">
                {t({
                  DE: "Alle Inhalte dieser Website (Texte, Bilder, Grafiken, Logos) unterliegen dem Urheberrecht. Jede Verwertung außerhalb der engen Grenzen des Urheberrechtsgesetzes bedarf der schriftlichen Zustimmung.",
                  EN: "All content on this site is protected by copyright. Any use outside the narrow limits of copyright law requires written consent.",
                  RU: "Все материалы защищены авторским правом. Любое использование за пределами законных рамок требует письменного согласия.",
                  UA: "Усі матеріали захищені авторським правом. Будь-яке використання потребує письмової згоди.",
                })}
              </p>
            </Block>
          </div>
        </div>
      </section>
    </div>
  );
}

function Block({ label, children }) {
  return (
    <div>
      <div className="eyebrow mb-4">{label}</div>
      <div>{children}</div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex justify-between py-3 border-b border-white/10 text-sm">
      <span className="text-white/55">{k}</span>
      <span className="text-white/90">{v}</span>
    </div>
  );
}
